export default __webpack_public_path__ + "static/Group7-b002cab89f6fb06da85b40521fdaae6e.svg";